/**************************************************************************************************************************************************
*   MODULE NAME     :  AbstractActions
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  08-02-2021
*   DESCRIPTION     :  Abstract API actions
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import * as types from "./actionTypes";
import AbstractApi from "../api/AbstractApi";

/******* ACTION OBJECTS *******/
export const loadAllCountrySuccess = countryData => {
  return {
    type: types.LOAD_ALL_COUNTRY_SUCCESS,
    countryData
  };
};

export const loadAllProductSuccess = productData => {
  return {
    type: types.LOAD_ALL_PRODUCT_SUCCESS,
    productData
  };
};

export const loadAllExplanationSuccess = explanationData => {
  return {
    type: types.LOAD_ALL_EXPLANATION_SUCCESS,
    explanationData
  };
};

export const loadAllStatusSuccess = statusData => {
  return {
    type: types.LOAD_ALL_STATUS_SUCCESS,
    statusData
  };
};

export const addAbstractSuccess = resp => {
  return {
    type: types.ADD_ABSTRACT_SUCCESS,
    resp
  };
};

export const addAbstractBulkSuccess = resp => {
  return {
    type: types.ADD_ABSTRACT_BULK_SUCCESS,
    resp
  }
}

export const updateAbstractSuccess = resp => {
  return {
    type: types.UPDATE_ABSTRACT_SUCCESS,
    resp
  };
};

export const loadAbstractDetailSuccess = abstractData => {
  return {
    type: types.LOAD_ABSTRACT_DETAIL_SUCCESS,
    abstractData
  }
}
export const loadAllAlertSuccess = abstractData => {
  return {
    type: types.LOAD_ALL_ALERTS_SUCCESS,
    abstractData
  }
}


/*****  ACTION DISPATCHERS  ******/

export const loadAllProduct = () => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAllProduct();
      dispatch(loadAllProductSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
};

export const loadAllCountry = () => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAllCountry();
      dispatch(loadAllCountrySuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
};

export const loadAllExplanation = () => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAllExplanation();
      dispatch(loadAllExplanationSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
};

export const loadAllStatus = () => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAllStatus();
      dispatch(loadAllStatusSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
};


export const loadAllAbstractsDataSuccess = data => {
  return {
    type: types.LOAD_ALL_ABSTRACT_DATA_SUCCESS,
    data
  };
};

export const loadAllAbstractsDataPaginationSuccess = data => {
  return {
    type: types.LOAD_ALL_ABSTRACT_DATA_PAGINATION_SUCCESS,
    data
  };
};

/**
 * ADD ABSTRACT DISPATCHER
 * @param {*} data 
 */
export const addAbstract = payload => {
  return async dispatch => {
    try {
      const response = await AbstractApi.addAbstract(payload);
      dispatch(addAbstractSuccess(response));
      return response;
    } catch (error) {
      throw error
    }
  }
}

export const addAbstractBulk = payload => {
  return async dispatch => {
    try {
      const response = await AbstractApi.addAbstractBulk(payload);
      dispatch(addAbstractBulkSuccess(response));
      return response;
    } catch (error) {
      throw error;
    }
  }
}

/**
 * EDIT ABSTRACT DISPATCHER
 * @param {*} data 
 */
export const updateAbstract = payload => {
  return async dispatch => {
    try {
      const response = await AbstractApi.updateAbstract(payload);
      dispatch(updateAbstractSuccess(response));
      return response;
    } catch (error) {
      throw error
    }
  }
}

export const loadAllAbstractsData = payload => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAllAbstractData(payload);
      dispatch(loadAllAbstractsDataSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
};

export const loadAllAbstractsDataPagination = payload => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAllAbstractDataPagination(payload);
      dispatch(loadAllAbstractsDataPaginationSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
}

export const loadAbstractDetail = payload => {
  return async dispatch => {
    try {
      const data = await AbstractApi.loadAbstractDetail(payload);
      dispatch(loadAbstractDetailSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
}
export const loadAllAlerts = () => {
  return async dispatch => {
    try {
      const data = await AbstractApi.getAlertMasterData();
      dispatch(loadAllAlertSuccess(data));
      return data;
    } catch (error) {
      throw error;
    }
  };
};


export const lockAbstract = (payload) => {
  return async () => {
    try {
      return await AbstractApi.lockAbstract(payload);
    } catch (error) {
      return error;
    }
  }
}


export const unlockAbstract = (payload) => {
  return async () => {
    try {
      return await AbstractApi.unlockAbstract(payload);
    } catch (error) {
      return error;
    }
  }
}

export const getAbstractLockedByData = (payload) => {
  return async () => {
    try {
      return await AbstractApi.getAbstractLockedByData(payload);
    } catch (error) {
      return error;
    }
  }
}


export const getAllLockedAbstractData = (payload) => {
  return async () => {
    try {
      return await AbstractApi.getAllLockedAbstractData(payload);
    } catch (error) {
      return error;
    }
  }
}

export const uploadAbstractAttachment = (payload)=>{
  return async () => {
    try {
      return await AbstractApi.uploadAbstractAttachment(payload);
    } catch (error) {
      return error;
    }
  }
}

export const addOrUpdateAbstractAttachment = (payload)=>{
  return async () => {
    try {
      return await AbstractApi.addOrUpdateAbstractAttachment(payload);
    } catch (error) {
      return error;
    }
  }
}

export const archiveAttachment = (payload)=>{
  return async () => {
    try {
      return await AbstractApi.archiveAttachment(payload);
    } catch (error) {
      return error;
    }
  }
}

export const loadAbstractAttachments = (payload)=>{
  return async () => {
    try {
      return await AbstractApi.loadAbstractAttachments(payload);
    } catch (error) {
      return error;
    }
  }
}

export const loadAllOrignalAbstractData = (payload)=>{
  return async () => {
    try {
      return await AbstractApi.loadAllOrignalAbstractData(payload);
    } catch (error) {
      return error;
    }
  }
}

